import { __awaiter } from 'tslib';

const ENDPOINT = 'UPDATEdashboardUserStatus';
function updateDashboardUserStatus(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.post(updateDashboardUserStatus.endpoint, params, params, customURL, customHeaders, null, isKoussa);
    });
}
updateDashboardUserStatus.endpoint = ENDPOINT;

export { updateDashboardUserStatus as default };
//# sourceMappingURL=updateDashboardUserStatus.js.map
